<template>
    <list-search v-bind="{ showsSearch }" @search="setQuery">
        <v-row align="center" class="ma-n2">
            <v-col class="pa-2" cols="12" sm="12" md="4">
                <v-select label="검색기간" v-model="query.searchDateKey" :items="searchDateKeys" v-bind="attrs_input" />
            </v-col>
            <v-col class="pa-2" cols="12" sm="6" md="4">
                <v-text-field v-model="query.searchDateValue[0]" type="date" max="2999-12-31" label="검색기간(시작)" clearable v-bind="attrs_input" />
            </v-col>
            <v-col class="pa-2" cols="12" sm="6" md="4">
                <v-text-field v-model="query.searchDateValue[1]" type="date" max="2999-12-31" label="검색기간(종료)" clearable v-bind="attrs_input" />
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import { attrs_input, USER_TYPES } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";
import AutocompleteUser from "@/components/dumb/autocomplete-user.vue";

let initQuery = (query = {}) => ({
    ...query,
    ["searchDateKey"]: query?.["searchDateKey"] || "createdAt",
    ["searchDateValue"]: query?.["searchDateValue"] || [null, null],
});

const searchDateKeys = [
    {
        text: "생성일시",
        value: "createdAt",
    },
    {
        text: "갱신일시",
        value: "updatedAt",
    },
];

export default {
    components: {
        ListSearch,
        AutocompleteUser,
    },
    props: {
        showsSearch: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        searchDateKeys,

        attrs_input,
        USER_TYPES,
    }),
    mounted() {
        this.sync();
    },

    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        setQuery() {
            const { ...query } = this.query || {};

            if (!query?.["searchDateValue"]) delete query["searchDateValue"];
            if (!query?.["searchDateValue"]?.[0] && !query?.["searchDateValue"]?.[1]) delete query["searchDateValue"];

            query.page = 1;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
